import axiosGraphQL from '../axiosGraphQL';

export interface IGetListRouteParams {
  page: number;
  pageSize: number;
  plantId: string;
  routeId?: string;
  statusId?: string;
  cityId?: string;
  districtId?: string;
  wardId?: string;
  customer?: string;
  type?: string;
  headerRow?: any;
}

export interface IUpdateTripDetailParams {
  id?: string;
  tripId: string;
  routeId: string;
  indexNum: number;
}

export interface ISearchRouteComboBox {
  value?: string;
  plantId?: string;
  pageSize: number;
  statusId?: 'R100_02' | 'R100_01';
}

export const GET_LIST_ROUTE = `
query GetRouteList($input:GetAllRouteListInput, $skip: Float $take: Float){
  getRouteList(where:$input, skip: $skip, take: $take){
    pageInfo{
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items{
      tripId
      tripName
      tripDetailId
      routeId
      routeName
      cityId
      cityName
      districtId
      districtName
      wardId
      wardName
      plantId
      companyId
      indexNum
      statusId
      validFromDate
      validToDate
      createDate
      modifyDate
      createUser
      modifyUser
      numExpectedDays
      areaId
      area{
        id
        cityId
        cityName
        districtId
        districtName
        wardId
        wardName
        cityNewId
        wardNewId
        cityNameNew
        wardNameNew
      }
    }
  }
}`;

export const VARIABLE_GET_LIST_ROUTE = (params: IGetListRouteParams) => {
  const {
    plantId,
    routeId,
    statusId,
    cityId,
    districtId,
    wardId,
    customer,
    page,
    pageSize,
  } = params;

  return {
    skip: (page - 1) * pageSize,
    take: pageSize,
    input: {
      plantId: plantId,
      hiddenYn: false,
      ...(routeId && { routeId: routeId }),
      ...(statusId && { statusId: statusId }),
      ...(cityId && { cityId: cityId }),
      ...(districtId && { districtId: districtId }),
      ...(wardId && { wardId: wardId }),
      ...(customer && { customer: customer }),
    },
  };
};

export const GET_All_ROUTE = `
query GetAllRouteMain($input: TrouteMWhereInput, $skip: Float, $take: Float) {
  getRouteM(where: $input, skip: $skip, take: $take, orderBy:[
    {createDate: DESC},
    {ttripDetail:{
        indexNum: ASC
    }}
  ]) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
      description
      numExpectedDays
      routeCode
      plantId
      validToDate
      validFromDate
      ttripDetail{
        id
        tripId
        ttrip{
            name
        }
        indexNum
      }
      tplant{
        id
        name
        areaName
        companyId
        companyName
      }
      tcheckInOuts {
        id
        tuser {
          id
          fullName
          avatar
          email
          phoneNumber
          role
          sloc
          departmentName
          latitude
          longitude
        }
        tcustomer {
          id
          storeName
          phone
          address
          email
          gender
          branchId
          urlImage1
          urlImage2
          urlImage3
          urlImage4
          urlImage5
          trank {
            id
            name
          }
          latitude
          longitude
        }
        checkInTime
        checkOutTime
        createDate
      }
      trouteAreas {
        id
        cityId
        cityNewId
        districtId
        wardId
        wardNewId
        useYn
        createId
        createDate
        tcity {
          id
          name
        }
        tdistrict {
          id
          name
        }
        tward {
          id
          name
        }
        tcityNew {
          id
          name
        }
        twardNew {
          id
          name
        }
        provinceId
        tprovince{
            id
            name
        }
      }
      trouteDetails {
        id
        customer {
          id
          storeName
          urlImage1
          urlImage2
          urlImage3
          urlImage4
          urlImage5
          phone
          address
          email
          dayofbirth
          latitude
          longitude
          gender
        }
        useYn
        createId
        createDate
      }
      tsalesPlannings {
        id
        name
        expectedRevenue
        implementationDate
        saleEndDate
        saleStartedDate
        teamSales {
          id
          name
          isWork
          plantId
          salesTeamCode
          createDate
          useYn
        }
        createDate
        approvalDate
      }
      tcreateUser{
        fullName
      }
      tmodifyUser{
        fullName
      }
      useYn
      createDate
      modifyDate
      modifyId
    }
  }
}`;

export const VARIABLES_GET_ALL_ROUTE_NO_PARAMS = async () => {
  return await axiosGraphQL.post('/graphql', {
    query: GET_All_ROUTE,
  });
};

export const VARIABLES_GET_ALL_ROUTE = (params: any) => {
  const {
    id,
    name,
    page,
    page_size,
    plantId,
    cityId,
    twardId,
    districtId,
    teamSalesId,
    useYn,
  } = params;

  return {
    skip: (page - 1) * page_size,
    take: page_size,
    input: {
      ...(id && { id: { contains: id } }),
      ...(name && {
        name: {
          contains: name,
        },
      }),
      ...(plantId && {
        plantId: {
          equals: plantId,
        },
      }),
      ...((cityId || districtId || twardId) && {
        trouteAreas: {
          ...(cityId && {
            cityId: {
              equals: cityId,
            },
          }),
          ...(districtId && {
            districtId: {
              equals: districtId,
            },
          }),
          ...(twardId && {
            wardId: {
              equals: twardId,
            },
          }),
        },
      }),
      ...(teamSalesId && {
        tsalesPlannings: {
          teamSalesId: {
            equals: teamSalesId,
          },
        },
      }),
      ...(useYn != undefined &&
        useYn != null && {
          useYn: {
            equals: useYn,
          },
        }),
    },
  };
};

export const QUERY_GET_ROUTE_DETAIL = `
query GetAllRouteDetail(
  $input: TrouteDetailWhereInput
  $skip: Float
  $take: Float
) {
  getRouteDetail(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      customerId
      expectedRevenue
      customer {
        id
        phone
        cccd
        address
        email
        gender
        latitude
        longitude
        sapCustomerId
        status
        storeName
        urlImage1
        urlImage2
        taxId
        rankId
        trank{
          name
        }
        tdistrict{
          name
        }
        tward{
          name
        }
        tcity{
          name
        }
        urlImage3
        urlImage4
        urlImage5
        tstatus{
          name
        }
      }
      routeId
      indexNum
      trouteM {
        id
        plantId
        name
        description
        numExpectedDays
        routeCode
        useYn
      }
      stopMk
      stopTime
      stopUser
      t2
      t3
      t4
      t5
      t6
      t7
      cn
      week1
      week2
      week3
      week4
      useYn
      createDate
      tcreateUser{
        id
        fullName
      }
      modifyDate
      tmodifyUser{
        id
        fullName
      }
    }
  }
}`;

export interface IGetRouteDetail {
  id: string;
  searchValue?: string;
}

export const VARIABLES_GET_ROUTE_DETAIL = ({
  id,
  searchValue = '',
}: IGetRouteDetail) => {
  return {
    input: {
      routeId: { equals: id },
      useYn: { equals: true },
      OR: [
        {
          customer: {
            id: {
              contains: searchValue,
            },
          },
        },
        {
          customer: {
            storeName: {
              contains: searchValue,
            },
          },
        },
        {
          customer: {
            sapCustomerId: {
              contains: searchValue,
            },
          },
        },
        {
          customer: {
            taxId: {
              contains: searchValue,
            },
          },
        },
      ],
    },
  };
};

export const QUERY_UPDATE_ROUTE_BY_ID = `
mutation UpdateRouteMain($data: TrouteMInput!){
  updateRouteM(input: $data){
    id
    name
    description
    numExpectedDays
    statusId
    validFromDate
    validToDate
    modifyId
    useYn
  }
}`;

export const VARIABLES_UPDATE_ROUTE = (params: any) => {
  const {
    id,
    name,
    statusId,
    modifyId,
    numExpectedDays,
    validFromDate,
    validToDate,
  } = params;

  return {
    data: {
      id,
      validToDate,
      ...(name && { name }),
      ...(statusId && { statusId }),
      ...(modifyId && { modifyId }),
      ...(numExpectedDays && { numExpectedDays }),
      ...(validFromDate && { validFromDate }),
      // ...(validToDate && { validToDate }),
    },
  };
};

export const QUERY_ADD_ROUTE = `
mutation CreateRouteMain($data: TrouteMInput!){
  createRouteM(input: $data){
    id
    name
    description
    numExpectedDays
    routeCode
    plantId
    createId
    useYn
    validFromDate
    validToDate
    statusId
  }
}`;

export const VARIABLES_ADD_ROUTE = (params: any) => {
  const {
    id,
    name,
    plantId,
    createId,
    numExpectedDays,
    validFromDate,
    validToDate,
    statusId,
  } = params;

  return {
    data: {
      ...(id && { id }),
      ...(name && { name }),
      ...(plantId && { plantId }),
      ...(createId && { createId }),
      ...(validFromDate && { validFromDate }),
      ...(validToDate && { validToDate }),
      ...(numExpectedDays && { numExpectedDays }),
      ...(statusId && { statusId }),
      useYn: true,
    },
  };
};

export const QUERY_ADD_ROUTE_AREA = `
mutation CreateManyRouteArea($data: [TrouteAreaInput!]!){
  createManyRouteArea(input: $data){
    id
    cityId
    cityNewId
    districtId
    wardId
    wardNewId
    useYn
    routeMId
  }
}`;

export const VARIABLES_ADD_ROUTE_AREA = (params: {
  data: any[];
  id: string;
}) => {
  const { id, data } = params;

  return {
    data: data.map((item) => ({
      routeMId: id,
      useYn: true,
      cityIdNew: item.cityNewId || item.cityId,
      ...(item.wardId || item.wardNewId
        ? {
            wardIdNew: item.wardNewId || item.wardId,
          }
        : {}),
      ...(item.districtId && { districtId: item.districtId }),
    })),
  };
};

export const QUERY_UPDATE_ROUTE_AREA = `
mutation UpdateRouteArea($data: [TrouteAreaInput!]!){
  updateManyRouteArea(input: $data){
    id
    cityId
    districtId
    wardId
    useYn
    routeMId
  }
}`;

export const VARIABLES_UPDATE_ROUTE_AREA = (params: {
  data: any[];
  id: string;
}) => {
  const { id, data } = params;

  return {
    data: data.map((item) => ({
      id: id,
      routeMId: id,
      cityId: item.tcity,
      wardId: item.tward,
      districtId: item.tdistrict,
    })),
  };
};

export const QUERY_UPDATE_INDEX_ROUTE = `mutation UpdateIndexNumRoute($input:[TrouteDetailInput!]!){
    updateManyRouteDetail(input:$input){
        id
        indexNum
    }
}`;

export const VARIABLES_UPDATE_INDEX_ROUTE = (
  params: { id: any; indexNum: number }[],
) => {
  return {
    input: [params[0], params[1]],
  };
};

export const QUERY_UPDATE_ROUTE_DETAIL = `mutation UpdateRouteDetail($data: TrouteDetailInput!){
    updateRouteDetail(input: $data){
        id
        customerId
        routeId
        useYn
        stopMk
        stopTime
        stopUser
        t2
        t3
        t4
        t5
        t6
        t7
        cn
        week1
        week2
        week3
        week4
    }
}`;

export interface IUpdateRouteDetail {
  id: string;
  customerId: string;
  t2: boolean;
  t3: boolean;
  t4: boolean;
  t5: boolean;
  t6: boolean;
  t7: boolean;
  cn: boolean;
  week1: boolean;
  week2: boolean;
  week3: boolean;
  week4: boolean;
  expectedRevenue: number;
}

export const generateParams = (params: IUpdateRouteDetail) => {
  const {
    id,
    customerId,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    cn,
    week1,
    week2,
    week3,
    week4,
    expectedRevenue,
  } = params;

  return {
    id,
    ...(customerId && { customerId }),
    ...(t2 != null && t2 != undefined && { t2 }),
    ...(t3 != null && t3 != undefined! && { t3 }),
    ...(t4 != null && t4 != undefined && { t4 }),
    ...(t5 != null && t5 != undefined && { t5 }),
    ...(t6 != null && t6 != undefined && { t6 }),
    ...(t7 != null && t7 != undefined && { t7 }),
    ...(cn != null && cn != undefined && { cn }),
    ...(week1 != null && week1 != undefined && { week1 }),
    ...(week2 != null && week2 != undefined && { week2 }),
    ...(week3 != null && week3 != undefined && { week3 }),
    ...(week4 != null && week4 != undefined && { week4 }),
    ...(expectedRevenue !== null &&
      expectedRevenue !== undefined && { expectedRevenue }),
  };
};

export const VARIABLES_UPDATE_ROUTE_DETAIL = (params: IUpdateRouteDetail) => {
  return { data: generateParams(params) };
};

// Get search customer by not route
export const QUERY_SEARCH_NOT_CUSTOMER_SALELINE = `
  query GetSearchCustomerNotRoute($input: CustNotInRouteInput,  $skip: Float, $take: Float){
      getCustomerNotInRoute(where: $input, skip: $skip, take:$take){
          pageInfo{
              currentPage
              hasNextPage
              hasPreviousPage
              itemsPerPage
              totalItems
              totalPages
          }
        items{
              sapCustomerId
              customerId
              cityId
              districtId
              storeName
              phone
              latitude 
              longitude
              address
              cityName
              districtName
              wardName
              isInArea
              rankName
              taxId
              cccd
        }
      }
  }
`;

export const VARIABLE_SEARCH_NOT_CUSTOM_SALELINE = ({
  custId,
  routeId,
  skip = 0,
  take = 20,
}: {
  custId: any;
  routeId: any;
  skip?: number;
  take?: number;
}) => {
  return {
    skip,
    take,
    input: {
      custId,
      routeId,
    },
  };
};

export const QUERY_ADD_CUSTOM_SALELINE = `mutation CreateRouteDetail($data: [TrouteDetailInput!]!){
    createManyRouteDetail(input: $data){
        id
        customerId
        routeId
        stopMk
        stopTime
        stopUser
        t2
        t3
        t4
        t5
        t6
        t7
        cn
        week1
        week2
        week3
        week4
        useYn
        createDate
        createId
    }
}`;

export const VARIABLE_ADD_CUSTOM_SALELINE = (
  routeId: any,
  listNewCustomer: any[],
) => {
  if (listNewCustomer?.length == 0 || !listNewCustomer?.length)
    return { data: undefined };
  return {
    data: listNewCustomer.map((item) => ({
      routeId,
      customerId: item.customerId,
      expectedRevenue: 0,
    })),
  };
};

// Get search Customer by not Teamsale
export const QUERY_SEARCH_NOT_CUSTOMER_TEAMSALE = `
  query GetCustomerNotInTeamSale($input: CustNotInTeamSalesInput!, $skip: Float, $take: Float){
      getCustomerNotInTeamSale(where: $input, skip: $skip, take:$take){
        pageInfo{
          currentPage
          hasNextPage
          hasPreviousPage
          itemsPerPage
          totalItems
          totalPages
        }
        items{
          customerId
          sapCustomerId
          storeName
          cityId
          phone
          districtId
          latitude
          longitude
          address
          cityName
          districtName
          wardName
          taxId
          cccd
        }
      }
  }
`;

export const VARIABLE_SEARCH_NOT_CUSTOM_TEAMSALE = ({
  custId,
  teamId,
  skip = 0,
  take = 20,
}: {
  custId: any;
  teamId: any;
  skip?: number;
  take?: number;
}) => {
  return {
    skip,
    take,
    input: {
      custId,
      teamId,
    },
  };
};

export const QUERY_SEARCH_NOT_CUSTOMER_TEAMSALE_SALELINE = `query GetCustomerNotInTeamOrRoute($input: CustNotInTeamOrRouteInput!){
    getCustomerNotInTeamOrRoute(where: $input){
       customerId
       sapCustomerId
       storeName
       cityId
       phone
       districtId
       latitude
       longitude
    }
}`;

export const VARIABLE_SEARCH_NOT_CUSTOM_TEAMSALE_SALELINE = (
  custId: any,
  teamId: any,
  routeId: any,
) => {
  return {
    input: {
      routeId,
      custId,
      teamId,
    },
  };
};

export const VARIABLE_GET_ALL_ROUTE_COMBOBOX = () => {
  return {
    input: {
      useYn: { equals: true },
    },
  };
};

export const QUERY_GET_ROUTE_COMBOBOX = `
  query GetAllRouteMain($input: TrouteMWhereInput, $skip: Float, $take: Float) {
    getRouteM(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        name
        description
        numExpectedDays
        tplant{
          id
          name
          areaName
          companyId
          companyName
        }
        useYn
        createDate
        modifyDate
        modifyId
      }
    }
  }
`;

export const QUERY_REMOVE_CUSTOMER = `
  mutation DeteleRouteDetail($input:TrouteDetailInput!){
    updateRouteDetail(input:$input){
        id
        useYn
    }
  }
`;

export const VARIABLE_REMOVE_CUSTOMER = (id: string) => {
  return {
    input: {
      id: id,
      useYn: false,
    },
  };
};

export const QUERY_UPDATE_TRIP_DETAIL = `
mutation UpdateTripDetailIndex($input:TtripDetailInput!){
    updateTripDetail(input:$input){
      id
      indexNum
      routeId
      tripId
    }
}`;

export const VARIABLE_UPDATE_TRIP_DETAIL = (
  params: IUpdateTripDetailParams,
) => {
  const { id, tripId, routeId, indexNum } = params;

  return {
    input: {
      ...(id && { id: id }),
      ...(tripId && { tripId: tripId }),
      ...(routeId && { routeId: routeId }),
      ...(indexNum && { indexNum: indexNum }),
    },
  };
};

export const QUERY_DELETE_ROUTE_AREA = `
mutation DeleteRouteArea($input: String!){
  deleteRouteArea(id: $input){
    code
    message
    success
  }
}`;

export const VARIABLES_DELETE_ROUTE_AREA = (id: string) => {
  return {
    input: id,
  };
};

export const QUERY_GET_LIST_ROUTE_COMBO_BOX = `
query GetAllRouteMain($input: TrouteMWhereInput, $skip: Float, $take: Float) {
  getRouteM(where: $input, skip: $skip, take: $take, orderBy:{id: ASC}) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      name
      description
      numExpectedDays
      tplant{
        id
        name
        areaName
        companyId
        companyName
      }
      statusId
      useYn
      createDate
      modifyDate
      modifyId
    }
  }
}`;

export const VARIABLES_GET_LIST_ROUTE_COMBO_BOX = (
  params: ISearchRouteComboBox,
) => {
  const { pageSize, value, plantId, statusId } = params;

  return {
    skip: 0,
    take: pageSize,
    input: {
      ...(plantId && { plantId: { equals: plantId } }),
      ...(statusId && { statusId: { equals: statusId } }),
      ...(value && {
        OR: [
          {
            id: {
              contains: value,
            },
          },
          {
            name: {
              contains: value,
            },
          },
        ],
      }),
    },
  };
};

export const CHECK_VALID_ROUTE_BY_ID = `
  query GetValidRouteMain($input: TrouteMWhereInput, $skip: Float, $take: Float) {
    getRouteM(where: $input, skip: $skip, take: $take, orderBy:[
      {createDate: DESC},
      {ttripDetail:{
          indexNum: ASC
      }}
    ]) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        name
        useYn
        createDate
        modifyDate
        modifyId
        validToDate
      }
    }
  }
`;

export interface ICheckValidRouteById {
  id: string;
}

export const VARIABLES_CHECK_VALID_ROUTE_BY_ID = (
  params: ICheckValidRouteById,
) => {
  return {
    input: {
      id: { equals: params.id },
      statusId: { equals: 'R100_01' },
    },
  };
};

export const GET_VALID_ROUTE_BY_ID = `
  query GetValidRouteMain($input: TrouteMWhereInput, $skip: Float, $take: Float) {
    getRouteM(where: $input, skip: $skip, take: $take, orderBy:[
      {createDate: DESC},
      {ttripDetail:{
          indexNum: ASC
      }}
    ]) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        name
        useYn
        createDate
        modifyDate
        modifyId
        validToDate
        statusId
      }
    }
  }
`;

export const CHECK_VALID_DATE_ROUTE_MAIN = `
  query CheckValidDateRoute($input:TrouteMWhereInput!){
      getRouteM(where:$input){
          items{
              id
              name
              validToDate
          }
      }
  }
`;

export const UPDATE_MANY_ROUTE_DETAIL = `
  mutation UpdateManyRouteDetail($data: [TrouteDetailInput!]!){
    updateManyRouteDetail(input: $data){
        id
        customerId
        routeId
        useYn
        stopMk
        stopTime
        stopUser
        t2
        t3
        t4
        t5
        t6
        t7
        cn
        week1
        week2
        week3
        week4
    }
  }
`;

export const UPDATE_MANY_ROUTE_DETAIL_VARIABLES = (
  data: IUpdateRouteDetail[],
) => {
  return { data: data.map((item) => generateParams(item)) };
};
